module.exports = __webpack_public_path__ + "static/media/icon-glass.06c48af5.svg";